// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./assets/iconfont.less
// module id = 4
// module chunks = 12